import { Component, input, output, computed } from '@angular/core';

@Component({
  standalone: true,
  imports: [],
  selector: 'shared-submit-button',
  template: `
    <button
      type="submit"
      [disabled]="disabled() || isLoading()"
      [class]="buttonClasses()"
      (click)="buttonClick.emit($event)"
    >
      @if (isLoading()) {
      <svg
        class="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          class="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          stroke-width="4"
        ></circle>
        <path
          class="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
      {{ loadingText() }}
      } @else {
      {{ buttonText() }}
      }
    </button>
  `,
})
export class SubmitButtonComponent {
  // Inputs
  buttonText = input<string>('Save');
  loadingText = input<string>('Loading...');
  isLoading = input<boolean>(false);
  disabled = input<boolean>(false);
  variant = input<'primary' | 'secondary' | 'danger'>('primary');
  size = input<'sm' | 'md' | 'lg'>('md');
  fullWidth = input<boolean>(false);
  borderRadius = input<
    'none' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | 'full'
  >('md');

  // Outputs
  buttonClick = output<Event>();

  // Computed classes
  buttonClasses = computed(() => {
    const baseClasses =
      'flex justify-center items-center border shadow-sm font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200';

    const borderRadiusClasses = {
      none: 'rounded-none',
      sm: 'rounded-sm',
      md: 'rounded-md',
      lg: 'rounded-lg',
      xl: 'rounded-xl',
      '2xl': 'rounded-2xl',
      '3xl': 'rounded-3xl',
      full: 'rounded-full',
    };

    const sizeClasses = {
      sm: 'px-3 py-1.5 text-sm',
      md: 'px-4 py-2 text-sm',
      lg: 'px-6 py-3 text-base',
    };

    const variantClasses = {
      primary:
        'border-transparent text-white bg-orange-600 hover:bg-orange-700 focus:ring-orange-500',
      secondary:
        'border-gray-300 text-gray-700 bg-white hover:bg-gray-50 focus:ring-orange-500',
      danger:
        'border-transparent text-white bg-red-600 hover:bg-red-700 focus:ring-red-500',
    };

    const widthClass = this.fullWidth() ? 'w-full' : '';

    return `${baseClasses} ${borderRadiusClasses[this.borderRadius()]} ${
      sizeClasses[this.size()]
    } ${variantClasses[this.variant()]} ${widthClass}`.trim();
  });
}
